// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G2XY","top":"styles_top__2oasN","left":"styles_left__YZVGM","description":"styles_description__27uEW"};